export default {
  // path: '/',
  meta: {
    title: '概览',
    url: '/overview', // 埋点用，记录所属模块
    // eventId: '4a81d3c2-5188-4dcf-a9f8-4a7f6a2389aa'
  },
};
